import { FC } from 'react'
import Swal from 'sweetalert2'
import {
  downloadArquivo,
  IconPaths,
  ModalSize,
  showAlertLoading,
  showError,
} from '../../../../../../../_metronic/helpers'
import { useAuth } from '../../../../../auth'
import { temVinculoMedicoAtivoNaEmpresa } from 'app/modules/auth/core/vinculos'
import {
  downloadRelatorioAtendimento,
  getAtendimentoById,
} from '../../../../atendimento/core/_requests'
import { RowActions, useModal, useToast } from '../../../../../../components'
import { downloadAllPrescricoes } from '../../core/_request'
import { HistoricoDetalhesModal } from '../../components/modal/HistoricoDetalhesModal'
import { AtendimentoPacienteList } from '../../../../atendimento/core/_models'

type Props = {
  atendimento: AtendimentoPacienteList
}

export const HistoricoActionsCell: FC<Props> = ({ atendimento }) => {
  const { showModal } = useModal()
  const { showToast } = useToast()
  const { currentUser } = useAuth()
  const atendimentoId = atendimento.id

  // Downloads só para médico ativo da instituição do atendimento (a linha já traz a empresa).
  const isMedico = temVinculoMedicoAtivoNaEmpresa(currentUser?.vinculos, atendimento.empresa?.id)

  const openDetalhes = () =>
    showModal({
      title: 'Visualização Atendimento',
      content: <HistoricoDetalhesModal />,
      size: ModalSize.Large,
      fetchers: {
        atendimento: () => getAtendimentoById(atendimentoId),
      },
    })

  const baixarAtendimento = async () => {
    try {
      showAlertLoading()
      const arquivo = await downloadRelatorioAtendimento(atendimentoId)
      downloadArquivo(arquivo)
      Swal.close()
    } catch (error) {
      showError(error)
    }
  }

  const baixarReceituario = async () => {
    try {
      showAlertLoading()
      const arquivos = await downloadAllPrescricoes(atendimentoId)
      Swal.close()
      if (!arquivos?.length) {
        showToast({ variant: 'info', title: 'Este atendimento não tem receituário.' })
        return
      }
      arquivos.forEach((arquivo) => downloadArquivo(arquivo))
    } catch (error) {
      showError(error)
    }
  }

  return (
    <RowActions
      itemName={`atendimento ${atendimento.protocolo ?? ''}`.trim()}
      primaryAction={{ label: 'Visualizar', onClick: openDetalhes, icon: IconPaths.Search }}
      items={[
        { label: 'Baixar atendimento', onClick: baixarAtendimento, hidden: !isMedico },
        { label: 'Baixar receituário', onClick: baixarReceituario, hidden: !isMedico },
      ]}
    />
  )
}
